<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch04">
<a id="page14">
<div class="chapterHead">
<h2 class="chapterTitle"> </h2>
</div>
</a><div class="chapterBody"><a id="page14">
<p class="chapterOpenerText"><span class="chapterOpenerFirstLetters"><span class="bold"><em class="italic">E</em></span></span>duardo Cortez lit a Cuban cigar. “Make no mistake, I do this for money. I risk my life only for money.” His eyes darted around the room as he spoke but in a manner that seemed a part of his frenetic nature rather than the surveillance that it was.</p>
</a><p class="para"><a id="page14">“You see that girl over there?” He turned and looked in the direction Cortez had nodded, a beautiful young Cuban girl. Her name was Ana Maria Varona and her hair was wild about her face, her shirt cut too low in the front so that the curve of her breasts was visible. She was sitting with a girlfriend laughing, her shoulders swaying as if she were about to break into a dance. For </a><a id="page15">a moment their eyes met and he saw something else in her stare.</a></p><a id="page15">
<p class="para">“She doesn’t work for money. We will pay her but that is not why she is here. Which one of us do you trust more?”</p>
<p class="para">He had to think about this.</p>
<p class="para">“I’ll answer for you,” said Eduardo. “I will tell you the right answer. Me, because I am not willing to die. Which one of us should Evangelina Cisneros trust? She should trust no one.</p>
<p class="para">“Her sisters are in a small fishing village with a woman who is pretending that she is their mother. Costanza has a baby. A little girl. Alicia. They say she looks very much the way Evangelina did. They’re safe. For now. Tell her this news and she will start to trust you. You must ask her where her father is. You must get her to tell you where her father is. Should she trust you? She should trust no one. But if you do your job properly, she will never know that. You see, she’s valuable either way. Possibly more dangerous if she dies. If José Martí had not died, then none of this would have happened…She will think that I am her friend. But, believe me, she should trust no one.”</p>
</a></div><a id="page15">
</a></div>
<a id="page15">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// whiterose_ch04.vue?364d564d